import React from 'react';
import { Col, Row, Stack } from 'react-bootstrap';
import { useState, useEffect } from "react";

function ProjectSummary ({ title, summary, imageUrl, altText, externalLink, linkText }) {
    return (
        <>
        <div className="project-summary">
            <Row>
                <Col className="left-column">
                    <h6><b>{title}</b></h6>
                    <p>{summary}</p>
                    <a href={externalLink}>{linkText}</a>
                    </Col>

            </Row>
            </div>
        </>
    );
};

export default ProjectSummary;